<template>
<section class="rent-report rent-report__period" v-if="storeReports?.length > 0">
  <div class="rent-report__period--wrap">
    <h2 class="rent-report__period-title">Отчеты за другие периоды</h2>
    <a class="rent-report__btn rent-report__btn--outline" href="/analytics/archive/?section=3837">
      <span class="rent-report__btn-txt">
        Архив отчетов
      </span>
    </a>
  </div>
  <div class="rent-report__period__reports-block">
    <div class="rent-report__period__reports-container">
      <div class="rent-report__period__reports-card" v-for="(item, idx) in storeReports" :key="`reports-card-${idx}`">
        <p class="rent-report__period__reports-card-text">
          {{ item.title }}
        </p>
        <a class="rent-report__period__reports-card-link" :href="item.link" target="_blank">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd"
              d="M5.68746 6C5.68746 5.44772 6.13518 5 6.68746 5H17C17.5523 5 18 5.44772 18 6V16.3125C18 16.8648 17.5523 17.3125 17 17.3125C16.4477 17.3125 16 16.8648 16 16.3125V8.41423L6.70711 17.7072C6.31659 18.0978 5.68342 18.0978 5.2929 17.7072C4.90237 17.3167 4.90237 16.6836 5.29289 16.293L14.5858 7H6.68746C6.13518 7 5.68746 6.55228 5.68746 6Z"
              fill="#82BF00" />
          </svg>
          <span>Перейти</span>
        </a>
      </div>
    </div>
  </div>
</section>
</template>
<script>
import axios from 'axios';

const API_URL = '/api/v2/content/analytics/rental-housing-report/';
export default {
  name: 'ReportPeriod',
  created() {
    this.getReports()
  },
  props: ['reportId'],
  computed: {},
  data() {
    return {
      period_id: 492718,
      storeReports: [],
    }
  },
  methods: {
    async getReports() {
      const data = await axios.get(`${API_URL}`)
        .then((response) => {
          this.storeReports = response.data.data.filter(report => report.id !== this.reportId)
          return response.data.data
        })
        .catch((err) => {
          console.log(err)
        })
    },
  },

}
</script>